import React, { useState } from "react";
import { Alert } from "react-bootstrap";

import AccountsOverview from "../pages/AccountsOverview";

function ProtectedPage() {
  const [show, setShow] = useState(false);

  return (
    <React.Fragment>
      {!!show && (
        <Alert
          className="mb-3"
          variant="primary"
          dismissible
          onClose={() => setShow(false)}
        >
          <div className="alert-message">
            This page is only visible by authenticated users.
          </div>
        </Alert>
      )}

      {/* <Default /> */}
      <AccountsOverview />
    </React.Fragment>
  );
}

export default ProtectedPage;
